export default __webpack_public_path__ + "static/media/Icons_Electric_Fill_Blue Icon.bcb98e37.svg";